/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import './contact.scss';
import Header from '../components/headerBar';
import Footer from '../components/footer';
import ADDRESS_ICON from '../assets/contact/address.png';
import EMAIL_ICON from '../assets/contact/email.png';
import PHONE_ICON from '../assets/contact/phone.png';
import QQ_ICON from '../assets/contact/qq.png';
import WECHAT_ICON from '../assets/contact/wechat.png';
import WECHAT from '../assets/homepage/wechat_connect.png';
import { Marker, Map } from 'react-bmap';
import { useLocation, useParams } from 'react-router-dom';

const map = Object.freeze({
  a: {
    en: 'Shandong Fantai Fine Chemical Biotechnology Co., Ltd.',
    'zh-cn': '山东钒泰精化生物科技有限公司',
  },
  b: {
    en: 'TELEPHONE',
    'zh-cn': '联系电话',
  },
  c: {
    en: 'ADDRESS',
    'zh-cn': '公司地址',
  },
  d: {
    en: 'MAILBOX',
    'zh-cn': '公司邮箱',
  },
  e: {
    en: 'QQ',
    'zh-cn': '公司QQ',
  },
  f: {
    en: 'WECHAT',
    'zh-cn': '公司微信',
  },
  g: {
    en: 'Free Trade Zone, Weifang City, Shandong Province',
    'zh-cn': '山东省潍坊市保税区',
  },
  h: {
    en: 'Please scan the QR code',
    'zh-cn': '请扫描二维码',
  },
  i: {
    en: 'to add customer service WeChat',
    'zh-cn': '添加客服微信',
  },
});

const Contact = () => {
  const location = useLocation();
  const [la, setLa] = useState('zh-cn');

  const { lang } = useParams();
  useEffect(() => {
    setLa(lang || 'en');
  }, [location.pathname]);

  return (
    <div className='contact'>
      <Header />
      <div className='contact-body'>
        <div className='first-wrap'>
          <div className='contact-box contact h160'>
            <div className='first-line'>
              <div className='title'>联系电话</div>
              <div className='icon'>
                <img src={PHONE_ICON} alt='' />
              </div>
            </div>
            <div className='main-content'>
              <div className='left'>
                <p className='sub-title'>对内贸易部</p>
                <p>公司总机：0536-2101172</p>
                <p>销售专线：0536-2101172</p>
                <p>移动电话：18678026865</p>
              </div>
              <div className='right'>
                <p className='sub-title'>Foreign Trade Department</p>

                <p>Marie Summer：+86 15336364684</p>
                <p className='br'>Wechat/Skype/Whatsapp</p>

                <p>Derek：+86 18678026865</p>
                <p className='br'>Wechat/Skype/Whatsapp</p>
              </div>
            </div>
          </div>

          <div className='map-wrap'>
            <Map
              center={{
                lat: 36.71179,
                lng: 119.248211,
              }}
              style={{
                width: '100%',
                height: '100%',
              }}
              zoom='16'
              // enableDragging={false}
            >
              <Marker
                position={{
                  lat: 36.71179,
                  lng: 119.248211,
                }}
                offset={new BMap.Size(-105, -50)}
              >
                <div
                  style={{
                    width: '250px',
                    height: '30px',
                    lineHeight: '30px',
                    background: '#fff',
                    textAlign: 'center',
                  }}
                >
                  {map.a[la]}
                </div>
              </Marker>
              <Marker
                position={{
                  lat: 36.71179,
                  lng: 119.248211,
                }}
                icon='location'
              ></Marker>
            </Map>
          </div>
        </div>
        <div className='second-wrap'>
          <div className='contact-box h120'>
            <div className='first-line'>
              <div className='title'>{map.c[la]}</div>
              <div className='icon'>
                <img src={ADDRESS_ICON} alt='' />
              </div>
            </div>
            <div className='main-content'>{map.g[la]}</div>
          </div>

          <div className='contact-box h120'>
            <div className='first-line'>
              <div className='title'>{map.d[la]}</div>
              <div className='icon'>
                <img src={EMAIL_ICON} alt='' />
              </div>
            </div>
            <div className='main-content'>
              sdfantai@163.com
              <br /> Derek@believechem.com
            </div>
          </div>

          <div className='contact-box h160'>
            <div className='first-line'>
              <div className='title'>{map.e[la]}</div>
              <div className='icon'>
                <img src={QQ_ICON} alt='' />
              </div>
            </div>
            <div className='main-content'>
              <div className='left'>
                <p>3007939906</p>
                <p>3007940023</p>
              </div>
              <div className='right'>
                <p>3007940113</p>
                <p>3007939904</p>
              </div>
            </div>
          </div>

          <div className='contact-box h200'>
            <div className='first-line'>
              <div className='title'>{map.f[la]}</div>
              <div className='icon'>
                <img src={WECHAT_ICON} alt='' />
              </div>
            </div>
            <div className='main-content wechat'>
              <div className='contact-detail'>
                <div>{map.h[la]}</div>
                <div>{map.i[la]}</div>
              </div>
              <div className='img-contaner'>
                <img src={WECHAT} alt='' />
              </div>
              <p></p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
